<template>
  <div style="height: 100%">
    <div v-if="$$debug.enabled" class="caption text-left ml-2 pt-1 pb-1 debug-area" :class="{mobile: $vuetify.breakpoint.smAndDown}">
      <v-chip class="rounded-sm debug-chip mb-1 mr-1" x-small>
        Debug Mode: <span class="font-weight-bold">Enabled</span>
      </v-chip>
      <v-chip class="rounded-sm debug-chip mb-1 mr-1" x-small>
        Breakpoint: <span :key="breakpointName" class="font-weight-bold" v-text="breakpointName"/>
      </v-chip>
      <v-chip class="rounded-sm debug-chip mb-1 mr-1" x-small>
        Endpoint:: <span class="font-weight-bold">{{ endpoint }}</span>
      </v-chip>
      <v-chip v-if="branchName" class="rounded-sm debug-chip mb-1 mr-1" x-small>
        Branch:: <span class="font-weight-bold">{{ branchName }}</span>
      </v-chip>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import {BreakpointName} from 'vuetify/types/services/breakpoint';

const ENDPOINT = process.env.VUE_APP_API_PATH;
const BRANCH_NAME = process.env.VUE_APP_GIT_BRANCH;

export default Vue.extend({
  data: () => ({
    breakpointName: '' as BreakpointName,
  }),
  computed: {
    endpoint(): string {
      return ENDPOINT?.replace(/.*\/\/:/g, '') || 'unknown';
    },
    branchName(): string | undefined {
      return BRANCH_NAME;
    },
  },
  methods: {
    onResize() {
      this.$nextTick(() => {
        this.breakpointName = this.$vuetify.breakpoint.name;
      });
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
});
</script>

<style scoped>
@keyframes updateIndicator {
  0% {
    background: rgba(100, 100, 100, 0.2) !important;
    filter: brightness(1);
  }
  5% {
    filter: brightness(2.5);
    background: rgba(255, 255, 255, 1.0) !important;
  }
  100% {
    filter: brightness(1);
    background: rgba(100, 100, 100, 0.2) !important;
  }
}

.debug-chip {
  background: rgba(100, 100, 100, 0.2) !important;
  animation: updateIndicator 2s infinite;
}

.debug-area {
  width: clamp(150px, 35vw, 400px);
  background-color: transparent;
  border-radius: 0;
  max-height: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
  transition: 0.5s;
  &.mobile:hover {
    margin: 12px;
    padding: 12px;
    background-color: rgba(100, 100, 100, 0.2);
    backdrop-filter: blur(10px);
    max-height: 300px;
  }
}
</style>
